import { useSortable } from "@dnd-kit/sortable";
import { CSS } from "@dnd-kit/utilities";
import styled from "styled-components";

export const DragHandleCell = styled.td`
  width: 1%;
  vertical-align: middle;
`;

export const DragHandle = styled.button`
  background: none;
  border: none;
  color: var(--aa-text-muted);
  padding: 0;
  /* Doubled class to out-rank Bootstrap's button:not(:disabled) pointer
     cursor. */
  && {
    cursor: grab;
  }
  &&:active {
    cursor: grabbing;
  }
`;

// A sortable row that hands its drag handle back to the children, so the
// handle can sit in the leftmost cell alongside the row's other cells.
const SortableItemRow = ({
  id,
  children,
}: {
  id: number;
  children: (dragHandle: React.ReactNode) => React.ReactNode;
}) => {
  const {
    attributes,
    listeners,
    setNodeRef,
    transform,
    transition,
    isDragging,
  } = useSortable({ id });
  return (
    <tr
      ref={setNodeRef}
      style={{
        transform: CSS.Translate.toString(transform),
        transition,
        opacity: isDragging ? 0.6 : undefined,
      }}
      data-testid="limited-list-item"
    >
      {children(
        <DragHandle
          type="button"
          className="bi-grip-vertical"
          data-testid="limited-list-drag-handle"
          {...attributes}
          {...listeners}
          // After the spreads, so dnd-kit's attributes cannot override it.
          aria-label="Reorder item"
        />
      )}
    </tr>
  );
};

export default SortableItemRow;
